import React, { useState, useEffect } from 'react';
import moment from 'moment';
import ArthaGateway from 'service/ArthaGateway';
import { CreditNote, Sale, SaleOrder, Receipt, VoucherSummary, Party } from 'service';
import { RootState } from 'store/store';
import { useSelector } from 'react-redux';
import { faCalendar, faDollarSign, faFileInvoice, faInr, faPhone, faReceipt, faWallet } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { durations } from 'service/Utils';

export const Receipts = () => {
    const user = useSelector((state: RootState) => state.appdata);
    const [party, setParty] = useState<Party>();
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [durationId, setDurationId] = useState<string>(moment().month() > 3 ? moment().year().toString() : moment().subtract(1, 'year').year().toString());
    const [receipts, setReceipts] = useState<Receipt[]>([]);
    const [voucherSummary, setVoucherSummary] = useState<VoucherSummary>();
    const [voucherType, setVoucherType] = useState<string>("receipt");
    const [pageNumber, setPageNumber] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(10);
    const [totalPages, setTotalPages] = useState<number>(5);
    
    useEffect(() => {
        if (user.profile) {
            setParty(user.profile.profile);
            setIsLoading(false);
        }
    }, [user]);

    useEffect(() => {
        loadReceipts();
    }, [party, pageNumber]);

    useEffect(() => {
        setReceipts([]);
        setPageNumber(1);

        // loadReceiptsSummary();
        loadReceipts();
    }, [durationId]);

    const loadReceipts = () => {
        if(!party || !party.id || party.id <= 0) {
            return;
        }
        setIsLoading(true);
        ArthaGateway
            .getReceipts(party?.id, durationId, 0, pageNumber, pageSize)
            .then((data) => {
                data.entries.map((receipt) => receipt.isExpanded = false);
                if (pageNumber > 1) {
                    setReceipts(receipts.concat(data.entries));
                }
                else {
                    setReceipts(data.entries);
                }

                setTotalPages(data.totalPages);
                setIsLoading(false);
            })
            .catch(error => {
                console.log(error);
                setIsLoading(false);
            });
    }

    const loadReceiptsSummary = () => {
        if(!party || !party.id || party.id <= 0) {
            return;
        }
        setIsLoading(true);
        ArthaGateway
            .getReceiptsSummary(party?.id, durationId, 0)
            .then((data) => {
                setVoucherSummary(data);
            })
            .catch(error => {
                console.log(error);
                setIsLoading(false);
            });
    }

    const toggleExapnd = (target) => {
        receipts.map((receipt) => {
            if (receipt.id === target.id) {
                receipt.isExpanded = !receipt.isExpanded;
            }
            else {
                receipt.isExpanded = false;
            }
        });
        setReceipts([...receipts]);
    }

    const viewReceiptData = (receipt: Receipt) => {
        ArthaGateway
            .getReceiptFileLink(receipt.id)
            .then((url) => {
                window.open(url, "_blank");
            })
            .catch(error => {
                console.log(error);
                setIsLoading(false);
            });
    }

    const currencyFormat = (value) =>
        new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'INR'
        }).format(value);

    return (
        <div className='page-receipts'>
            <div className="row">
                <div className="col-md-12">
                    <div className="card bg-dark text-white mb-2">
                        <div className="card-header">
                            <h2 className="fw-bold mb-4">Receipts</h2>
                            <div>
                                <select className="form-control" id="duration" value={durationId} onChange={(e) => setDurationId(e.target.value)}>
                                    {durations.map((duration) => (
                                        <option key={duration.value} value={duration.value}>{duration.label}</option>
                                    ))}
                                    <option value="-1">Other</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="row mt-2">
                        <div className='col-12 cold-md-6 col-lg-4'>
                            {isLoading &&
                                <div className="text-center" style={{ padding: 20 }}>
                                    <div className="spinner-border text-dark" role="status">
                                    </div>
                                </div>
                            }
                            {receipts.length === 0 && !isLoading &&
                                <div className="alert alert-danger text-center" style={{ margin: 10 }}>
                                    No receipts found
                                </div>
                            }
                            {receipts && receipts.map((receipt) => (
                                <div className='card my-2' key={receipt.id}>
                                    <div className="card-header text-center">
                                        <h2 className="fw-bold">{receipt.voucherNumber}</h2>
                                    </div>
                                    <div className="card-body p-0">
                                        <table className="table table-sm mb-0">
                                            <tbody>
                                                <tr className="align-middle">
                                                    <td style={{ width: "60px", fontSize: "1.5rem", textAlign: "center" }}>
                                                        <FontAwesomeIcon icon={faCalendar} />
                                                    </td>
                                                    <td>
                                                        Date:
                                                        <div className="fw-bold">{moment(receipt.date).format("DD MMM YYYY")}</div>
                                                    </td>
                                                </tr>
                                                <tr className="align-middle">
                                                    <td style={{ width: "60px", fontSize: "1.5rem", textAlign: "center" }}>
                                                        <FontAwesomeIcon icon={faInr} />
                                                    </td>
                                                    <td>
                                                        Amount:
                                                        <div className="fw-bold">{currencyFormat(receipt.amount)}/-</div>
                                                    </td>
                                                </tr>
                                                
                                                <tr className="align-middle">
                                                    <td style={{ width: "60px", fontSize: "1.5rem", textAlign: "center" }}>
                                                        <FontAwesomeIcon icon={faWallet} />
                                                    </td>
                                                    <td>
                                                        Mode:
                                                        <div className="fw-bold">{receipt.paymentType}
                                                            {receipt.referenceNumber && receipt.referenceNumber.length > 0 && <> - {receipt.referenceNumber}</>}
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="card-footer">
                                        {/*<div className="btn btn-dark w-100" title="View" onClick={() => viewReceiptData(receipt)}>
                                            <FontAwesomeIcon icon={faFileInvoice} style={{ width: "auto" }} />
                                            &nbsp; Download Receipt
                                        </div>*/}
                                    </div>
                                </div>
                            ))}
                        </div>
                        <div className="card-footer">
                            {(totalPages > pageNumber) &&<>
                                {isLoading &&
                                    <div className="btn btn-dark w-100 text-center">
                                        <div className="spinner-border text-light" role="status">
                                        </div>
                                        </div>
                                    }
                                    {!isLoading &&
                                        <div className="btn btn-dark w-100 text-center" onClick={() => setPageNumber(pageNumber + 1)}>Load More...</div>
                                    }
                                </>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
};